import { render, staticRenderFns } from "./inputUpload.vue?vue&type=template&id=24d3be64&scoped=true"
import script from "./inputUpload.vue?vue&type=script&lang=js"
export * from "./inputUpload.vue?vue&type=script&lang=js"
import style0 from "./inputUpload.vue?vue&type=style&index=0&id=24d3be64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d3be64",
  null
  
)

export default component.exports